module.exports = __webpack_public_path__ + "static/media/6-1.02870dee.webp";